export const solidIcons = [
    "address-book","address-card","align-center","align-justify","align-left","align-right",
    "anchor","angle-double-down","angle-double-left","angle-double-right","angle-double-up",
    "angle-down","angle-left","angle-right","angle-up","archive","arrow-down","arrow-left",
    "arrow-right","arrow-up","asterisk","at","baby","ban","bars","bath","battery-empty",
    "battery-full","battery-half","bed","beer","bell","bell-slash","bold","bolt","bomb",
    "book","bookmark","box","briefcase","bug","building","bullhorn","calculator","calendar",
    "calendar-alt","calendar-check","camera","car","cart-shopping","chart-bar","chart-line",
    "chart-pie","check","check-circle","check-square","chevron-down","chevron-left",
    "chevron-right","chevron-up","circle","clock","cloud","code","cog","comment","compass",
    "copy","credit-card","cube","database","desktop","download","edit","ellipsis-h",
    "ellipsis-v","envelope","envelope-open","exclamation","exclamation-circle",
    "exclamation-triangle","eye","eye-slash","file","file-alt","filter","flag","folder",
    "folder-open","forward","frown","gift","globe","graduation-cap","grip-horizontal",
    "grip-vertical","hashtag","heart","history","home","hotel","hourglass","id-badge",
    "id-card","image","inbox","infinity","info","info-circle","key","laptop","layer-group",
    "leaf","lightbulb","link","list","lock","lock-open","map","map-marker","map-marker-alt",
    "map-pin","medal","microphone","minus","minus-circle","mobile","mobile-alt","money-bill",
    "moon","music","newspaper","paper-plane","paperclip","pause","pen","pencil-alt","phone",
    "phone-alt","plus","plus-circle","print","question","question-circle","quote-left",
    "quote-right","redo","reply","rss","save","search","share","shield","sign-in-alt",
    "sign-out-alt","signal","sliders-h","smile","sort","sort-amount-down","sort-amount-up",
    "spinner","star","star-half","stopwatch","sun","sync","table","tag","tags","thumbs-down",
    "thumbs-up","ticket-alt","times","times-circle","toggle-off","toggle-on","trash",
    "trash-alt","trophy","truck","undo","upload","user","user-alt","user-check","user-circle",
    "user-cog","user-friends","user-minus","user-plus","user-times","users","utensils",
    "video","wallet","wifi","wrench","plane","train","bus","bicycle","motorcycle","ship",
    "passport","suitcase","suitcase-rolling","concierge-bell","door-open","door-closed",
    "spa","swimming-pool","hot-tub","dumbbell","futbol","golf-ball","basketball-ball",
    "volleyball-ball","chess","dice","puzzle-piece","palette","paint-brush","camera-retro",
    "film","music","headphones","microphone-alt","tv","laptop-code","terminal","code-branch",
    "project-diagram","sitemap","network-wired","server","hdd","memory","microchip",
    "robot","satellite","broadcast-tower","podcast","comment-dots","comments",
    "sms","comment-alt","fax","voicemail","pager","phone-square"
];

export const regularIcons = [
    "address-book","address-card","bell","bookmark","building",
    "calendar","calendar-check","chart-bar","circle","circle-check",
    "circle-dot","circle-pause","circle-play","circle-question","circle-stop",
    "circle-user","circle-xmark","clipboard","clock","comment",
    "comment-dots","comments","compass","copy","credit-card",
    "envelope","envelope-open","eye","eye-slash",
    "face-angry","face-dizzy","face-flushed","face-frown","face-frown-open",
    "face-grimace","face-grin","face-grin-beam","face-grin-squint","face-grin-wink",
    "face-kiss","face-kiss-beam","face-laugh","face-laugh-beam",
    "face-meh","face-rolling-eyes","face-sad-cry","face-sad-tear",
    "face-smile","face-smile-beam","face-smile-wink","face-surprise","face-tired",
    "file","file-audio","file-code","file-excel","file-image",
    "file-lines","file-pdf","file-powerpoint","file-video","file-word",
    "flag","floppy-disk","folder","folder-open","gem",
    "hand","hand-lizard","hand-peace","hand-point-down","hand-point-left",
    "hand-point-right","hand-point-up","hand-pointer","hand-scissors","hand-spock",
    "handshake","hard-drive","heart","hospital","hourglass",
    "id-badge","id-card","image","keyboard","lemon",
    "life-ring","lightbulb","map","message","moon",
    "newspaper","note-sticky","object-group","object-ungroup","paper-plane",
    "pen-to-square","rectangle-list","registered","share-from-square","snowflake",
    "square","square-check","square-minus","square-plus",
    "star","star-half","sun","thumbs-down","thumbs-up",
    "trash-can","user","window-maximize","window-minimize"
];

export const brandsIcons = [
    "amazon","android","angular","apple","behance","bitcoin","bootstrap","chrome","codepen",
    "css3","dev","discord","docker","dribbble","dropbox","ethereum","facebook","figma",
    "firefox","github","gitlab","google","html5","instagram","java","jira","js","laravel",
    "linkedin","microsoft","node","node-js","npm","paypal","php","pinterest","python",
    "react","reddit","sass","skype","slack","soundcloud","spotify","stack-overflow",
    "steam","swift","telegram","tiktok","trello","tumblr","twitch","twitter","ubuntu",
    "vimeo","vue","whatsapp","windows","wordpress","yarn","youtube","airbnb","alipay",
    "atlassian","aws","azure","bitbucket","cloudflare","confluence","debian","digitalocean",
    "edge","fedora","git","google-pay","google-play","google-plus","hackerrank",
    "internet-explorer","jenkins","joomla","linux","medium","mendeley","opera","patreon",
    "product-hunt","quora","raspberry-pi","redhat","researchgate","shopify","snapchat",
    "square-font-awesome","strava","stripe","stumbleupon","superpowers",
    "symfony","teamspeak","the-red-yeti","themeco","unity","uikit","usps",
    "vaadin","vigilant","vk","vimeo-v","vine","viber","waze","weibo","weixin",
    "wikipedia-w","wix","wolf-pack-battalion","xbox","xing","y-combinator","yammer",
    "yandex","yelp","yoast"
];
